export const DESTINATION_TEXTS = {
  fieldLabelFixed: 'Куда',
  placeholder: 'Страна, курорт или отель',
  selectAll: 'Все курорты',
  nothingFound: 'Ничего не найдено',
  groupPopularCountries: 'Популярные направления',
  groupOtherCountries: 'Остальные направления',
  groupPopularResorts: 'Популярные курорты',
  groupOtherResorts: 'Остальные курорты',
  errorEmpty: 'Начните с выбора направления',
  errorInvalid: 'Неверное направление',
} as const;

export const DESTINATION_MOBILE_TEXTS = {
  searchPlaceholder: 'Страна, курорт, отель',
  searchResortsPlaceholder: 'Поиск по курортам',
  searchHotelsPlaceholder: 'Поиск по отелям',
  recentTitle: 'Вы недавно искали',
  popularTitle: 'Популярные направления',
  groupCountries: 'Страны',
  groupResorts: 'Курорты',
  groupHotels: 'Отели',
  hotelsHint: 'Начните вводить название отеля',
  emptyTitle: 'Ничего не нашлось',
  emptyHint: 'Проверьте на ошибки или поищите\nдругие направления',
  next: 'Выбрать',
  switchCountryTitle: 'Сменить страну?',
  switchCountryText: (current: string, next: string): string =>
    `Тур ищется по одной стране. Если выбрать «${next}», выбор по «${current}» сбросится.`,
  switchCountryConfirm: 'Сменить страну',
  switchToHotelsTitle: 'Выбрать отель?',
  switchToResortsTitle: 'Выбрать курорт?',
  switchModeText: (name: string, toHotels: boolean): string =>
    `Тур ищется либо по курортам, либо по отелям. Если выбрать «${name}», выбор ${
      toHotels ? 'курортов' : 'отелей'
    } сбросится.`,
  switchToHotelsConfirm: 'Выбрать отель',
  switchToResortsConfirm: 'Выбрать курорт',
  cancel: 'Оставить как есть',
} as const;
